import IconButton from '@material-ui/core/IconButton';
import {
  KeyboardArrowLeft,
} from '@material-ui/icons';
import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import {
  RouteComponentProps, withRouter,
} from 'react-router';
import * as Yup from 'yup';
import {
  FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import Spinner from '../../components/Spinner';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  IAuthStore, ICountry,
} from '../../mobx-store/storeInterfaces/authInterface';
import {
  IEventCategoryStore,
} from '../../mobx-store/storeInterfaces/eventsCategoryInterface';
import {
  IEventStore,
  Image,
} from '../../mobx-store/storeInterfaces/eventsInterface';
import classes from './addEditEvents.module.scss';
import AlertDialog from 'components/Dialog/alertDialog';
import UploadProgressModal from 'components/uploadProgressModal';

interface Props extends WithSnackbarProps {
  eventStore: IEventStore;
  authStore: IAuthStore;
  eventCategoryStore: IEventCategoryStore;
  match: any;
  history: any;
}

interface State {
  processing: boolean;
  formFields: FormField[];
  loadingCategories: boolean;
  loadingEvent: boolean;
  uploadModalOpen: boolean;
}

@inject('eventStore')
@inject('authStore')
@inject('eventCategoryStore')
@observer
class AddEditEvent extends Component<Props & RouteComponentProps, State> {
  isNew = false;

  eventId = -1;

  lastHistory = -1;

  eventFormTitle = '';

  eventSchema: any;

  submitButton: any;

  cancelButton: any;

  initGallery: Image[] = [];

  defaultForm: FormField[] = [
    {
      name: 'title',
      label: translate('addEventPageFormName', {
      }),
      type: 'text',
      filedType: 'InputField',
    },
    {
      name: 'description',
      label: translate('addEventPageFormDescription', {
      }),
      type: 'text',
      filedType: 'InputField',
    },
    {
      name: 'eventCategoryId',
      label: translate('addEventPageFormCategory', {
      }),
      selectList: [],
      selectListValue: 'title',
      selectListKey: 'eventCategoryId',
      filedType: 'DropdownField',
    },
    {
      name: 'imageURL',
      label: translate('addEventPageFormGallery', {
      }),
      filedType: 'GalleryField',
      accept: 'image/*',
      size: 200,
      hideProgressBar: true,
    },
    {
      name: 'images',
      label: translate('addAcademyPageFormGallery', {
      }),
      filedType: 'GalleryField',
      accept: 'image/*',
      size: 200,
      hideProgressBar: true,
    },
    {
      name: 'isAllDay',
      label: translate('addEventPageFormAllDay', {
      }),
      filedType: 'ToggleButtonField',
      activeLabel: translate('addEventPageFormAllDay', {
      }),
      inactiveLabel: translate('addEventPageFormAllDay', {
      }),
      value: false,
    },
    {
      name: 'startDate',
      label: translate('addEventPageFormStartDate', {
      }),
      filedType: 'DatePickerField',
      withTimePicker: true,
      minDate: this.isNew ? new Date() : undefined,
    },
    {
      name: 'endDate',
      label: translate('addEventPageFormEndDate', {
      }),
      filedType: 'DatePickerField',
      withTimePicker: true,
      minDate: this.isNew ? new Date() : undefined,
    },
    {
      name: 'isActive',
      label: translate('addEventPageFormStatus', {
      }),
      filedType: 'ToggleButtonField',
      activeLabel: translate('addEventPageFormStatusActiveLabel', {
      }),
      inactiveLabel: translate('addEventPageFormStatusInactiveLabel', {
      }),
      value: true,
    },
  ];

  allDayFormFields: FormField[] = [
    {
      name: 'title',
      label: translate('addEventPageFormName', {
      }),
      type: 'text',
      filedType: 'InputField',
    },
    {
      name: 'description',
      label: translate('addEventPageFormDescription', {
      }),
      type: 'text',
      filedType: 'InputField',
    },
    {
      name: 'eventCategoryId',
      label: translate('addEventPageFormCategory', {
      }),
      selectList: [],
      selectListValue: 'title',
      selectListKey: 'eventCategoryId',
      filedType: 'DropdownField',
    },
    {
      name: 'imageURL',
      label: translate('addEventPageFormGallery', {
      }),
      filedType: 'GalleryField',
      accept: 'image/*',
      size: 200,
      hideProgressBar: true,
    },
    {
      name: 'images',
      label: translate('addAcademyPageFormGallery', {
      }),
      filedType: 'GalleryField',
      accept: 'image/*',
      size: 200,
      hideProgressBar: true,
    },
    {
      name: 'isAllDay',
      label: translate('addEventPageFormAllDay', {
      }),
      filedType: 'ToggleButtonField',
      activeLabel: translate('addEventPageFormAllDay', {
      }),
      inactiveLabel: translate('addEventPageFormAllDay', {
      }),
      value: false,
    },
    {
      name: 'startDate',
      label: translate('addEventPageFormStartDate', {
      }),
      filedType: 'DatePickerField',
      minDate: this.isNew ? new Date() : undefined,
    },
    {
      name: 'isActive',
      label: translate('addEventPageFormStatus', {
      }),
      filedType: 'ToggleButtonField',
      activeLabel: translate('addEventPageFormStatusActiveLabel', {
      }),
      inactiveLabel: translate('addEventPageFormStatusInactiveLabel', {
      }),
      value: true,
    },
  ];

  constructor(props: Props & RouteComponentProps) {
    super(props);
    this.initializeComponent(props);
  }

  componentDidMount() {
    this.getEventCategories();

    const {
      eventStore,
    } = this.props;
    const {
      getEventById,
    } = eventStore;
    if (!this.isNew) {
      getEventById(this.eventId)
        .then(() => {
          const {
            selectedEvent,
          } = eventStore;
          const {
            isAllDay,
          } = selectedEvent;
          const {
            formFields,
          } = this.state;

          const formFieldsWithData: any[] = [];
          formFields.forEach((field) => {
            if (isAllDay && field.name === 'endDate') {
              return;
            }
            formFieldsWithData.push({
              ...field,
              value: selectedEvent[field.name],
            });
          });
          this.initGallery = Object.assign([], this.props.eventStore.selectedEvent.images);
          this.setState({
            formFields: formFieldsWithData,
            loadingEvent: false,
            loadingCategories: false,
          });
        }).catch(() => {
          this.setState({
            loadingEvent: false,
          });
        });
    }
  }

  handleSubmit = async (values: any) => {
    const {
      eventStore, history, authStore,
    } = this.props;
    values.availableCountries = authStore.userData.countries.map((country: ICountry) => country.isoCode);
    this.setState({
      processing: true,
      uploadModalOpen: true,
    });
    if (this.isNew) {
      eventStore.createEvent(values)
        .then(() => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('createdMessage', {
          }), 6000, 'success');
          history.push('/events');
        }).catch(() => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 4000, 'error');
        });
    } else {
      eventStore.updateEvent(values, this.eventId, this.initGallery)
      .then(() => {
        this.setState({
          processing: false,
        });
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
        }), 6000, 'success');
        history.go(this.lastHistory);
      });
    }
  };

  navigateBack = () => {
    const {
      history,
    } = this.props;
    history.goBack();
  };

  getSubmitButton = () => ({
    title: (this.isNew ? 'Submit' : 'Save Changes'),
    onSubmit: this.handleSubmit,
  });

  getCancelButton = () => ({
    title: 'Cancel',
    onCancel: this.navigateBack,
  });

  updateStateWithCategoriesData = () => {
    const {
      eventCategoryStore,
    } = this.props;
    const {
      eventCategoryList,
    } = eventCategoryStore;
    const {
      formFields,
    } = this.state;
    const formFieldsWithData: any[] = [];
    const allDayformFieldsWithData: any[] = [];
    formFields.forEach((field) => {
      if (field.name === 'eventCategoryId') {
        formFieldsWithData.push({
          ...field, selectList: eventCategoryList,
        });
      } else {
        formFieldsWithData.push(field);
      }
    });
    this.allDayFormFields.forEach((field) => {
      if (field.name === 'eventCategoryId') {
        allDayformFieldsWithData.push({
          ...field, selectList: eventCategoryList,
        });
      } else {
        allDayformFieldsWithData.push(field);
      }
    });
    this.allDayFormFields = allDayformFieldsWithData;
    this.defaultForm = formFieldsWithData;
    this.setState({
      formFields: formFieldsWithData,
      loadingCategories: false,
    });
  };

  getEventCategories = () => {
    this.setState({
      loadingCategories: true,
    });
    const {
      eventCategoryStore,
    } = this.props;
    eventCategoryStore.getEventCategory()
      .then(() => {
        this.updateStateWithCategoriesData();
      }).catch(() => {
        this.setState({
          loadingCategories: false,
        });
      });
  };

  initState = (isConstructor = true) => {
    const initState: State = {
      processing: false,
      loadingEvent: !this.isNew,
      loadingCategories: true,
      uploadModalOpen: false,
      formFields: [
        {
          name: 'title',
          label: translate('addEventPageFormName', {
          }),
          type: 'text',
          filedType: 'InputField',
        },
        {
          name: 'description',
          label: translate('addEventPageFormDescription', {
          }),
          type: 'text',
          filedType: 'InputField',
        },
        {
          name: 'eventCategoryId',
          label: translate('addEventPageFormCategory', {
          }),
          selectList: [],
          selectListValue: 'title',
          selectListKey: 'eventCategoryId',
          filedType: 'DropdownField',
        },
        {
          name: 'imageURL',
          label: translate('addEventPageFormGallery', {
          }),
          filedType: 'GalleryField',
          accept: 'image/*',
          size: 200,
          hideProgressBar: true,
        },
        {
          name: 'images',
          label: translate('addAcademyPageFormGallery', {
          }),
          filedType: 'GalleryField',
          accept: 'image/*',
          size: 200,
          hideProgressBar: true,
        },
        {
          name: 'isAllDay',
          label: translate('addEventPageFormAllDay', {
          }),
          filedType: 'ToggleButtonField',
          activeLabel: translate('addEventPageFormAllDay', {
          }),
          inactiveLabel: translate('addEventPageFormAllDay', {
          }),
          value: false,
        },
        {
          name: 'startDate',
          label: translate('addEventPageFormStartDate', {
          }),
          filedType: 'DatePickerField',
          withTimePicker: true,
          minDate: this.isNew ? new Date() : undefined,
        },
        {
          name: 'endDate',
          label: translate('addEventPageFormEndDate', {
          }),
          filedType: 'DatePickerField',
          withTimePicker: true,
          minDate: this.isNew ? new Date() : undefined,
        },
        {
          name: 'isActive',
          label: translate('addEventPageFormStatus', {
          }),
          filedType: 'ToggleButtonField',
          activeLabel: translate('addEventPageFormStatusActiveLabel', {
          }),
          inactiveLabel: translate('addEventPageFormStatusInactiveLabel', {
          }),
          value: true,
        },
      ],
    };
    if (isConstructor) {
      this.state = initState;
    } else {
      this.setState(initState);
    }
  };

  initEventSchema = () => {
    this.eventSchema = Yup.object().shape({
      title: Yup.string().required('Required'),
      description: Yup.string().required('Required'),
      eventCategoryId: Yup.number().required('Required'),
      imageURL: Yup.array().required('Required'),
      startDate: Yup.date().typeError('Invalid date').required('Required'),
      endDate: Yup.date().nullable(true)
        .when('isAllDay', {
          is: false,
          then: Yup.date().typeError('Invalid date').required('Required'),
        })
        .when('startDate', (startDate: Date) => Yup.date().min(startDate).nullable(true)),
      isAllDay: Yup.boolean().default(false),
      isActive: Yup.boolean().default(true),
    });
  };

  onChangeValues = async (key: any, value: any) => {
    if (key === 'isAllDay') {
      if (value === true) {
        this.setState({
          formFields: this.allDayFormFields,
        });
      }
      if (value === false) {
        this.setState({
          formFields: this.defaultForm,
        });
      }
    }
  };

  initializeComponent(props: Props & RouteComponentProps, isConstructor = true) {
    if (props.match.params.id) {
      this.isNew = false;
      this.eventId = props.match.params.id;
      this.eventFormTitle = translate('editEventPageTitle', {
      });
    } else {
      this.isNew = true;
      this.eventFormTitle = translate('addEventPageTitle', {
      });
    }
    this.initEventSchema();
    this.initState(isConstructor);
    this.submitButton = this.getSubmitButton();
    this.cancelButton = this.getCancelButton();
  }

  handleDismissUploadModal = () => {
    this.setState({
      uploadModalOpen: false,
    })
  }

  render() {
    const {
      loadingEvent,
      processing,
      formFields,
      loadingCategories,
    } = this.state;
    const {
      history,
    } = this.props;
    return (
      <div className={classes.container}>
        <div className={classes.header}>
          <IconButton
            className={classes.backButton}
            onClick={() => history.goBack()}
            aria-label="Back"
          >
            <KeyboardArrowLeft />
          </IconButton>
        </div>
        <div className={classes.content}>
          <UploadProgressModal
            imagesProgresses={this.props.eventStore.imagesProgresses}
            isOpen={this.state.uploadModalOpen}
            handleDismiss={this.handleDismissUploadModal}
          />
          <AlertDialog
            title="failed to upload these images"
            content={() => {
              let images = this.props.eventStore.failedImages.map((image) => {
                return (
                  <img
                    style={{ height: 100, width: 100, margin: 5 }}
                    src={image.preview}
                  />
                );
              });
              return <div>{images}</div>;
            }}
            isOpen={this.props.eventStore.isAlertOpened}
            buttonText="ok"
            handleClose={() => {
              this.props.eventStore.onDismissAlert();
            }}
          />
          {loadingEvent || loadingCategories ? (
            <Spinner />
          ) : (
            <GeneralFormComponent
              formTitle={this.eventFormTitle}
              fields={formFields}
              formSchema={this.eventSchema}
              submitButton={this.submitButton}
              cancelButton={this.cancelButton}
              processing={processing}
              onChangeValues={(key: any, value: any) =>
                this.onChangeValues(key, value)
              }
            />
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(AddEditEvent);
